module.exports = __webpack_public_path__ + "static/media/notification.651771e1.woff";